// extracted by mini-css-extract-plugin
export default {"msgIcon":"style_msgIcon__do7gq","CustomEmpty":"style_CustomEmpty__TOsPT","EmptyIcon":"style_EmptyIcon__tWI0t","EmptyText":"style_EmptyText__gZfQJ"};